module.exports = __webpack_public_path__ + "img/BankWIR_Logo_CMYK_EN_ED_RM.94f98e0a.png";